import { Injectable } from "@angular/core";
import { getBaseUrl } from "../app/app.config";

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    isDevMode: boolean;

    setEnvironment() {
        this.isDevMode = getBaseUrl().includes('dev') || getBaseUrl().includes('localhost');
    }
}